"use client";

/**
 * Client redirect to a saved /c page (2026-07-31).
 *
 * When a search resolves to a saved comparison, /compare used to do a SERVER
 * redirect() to /c/<slug>. On a client navigation that is a TWO-STEP fetch
 * (/compare RSC -> redirect -> /c RSC), and the gap between the /compare scene
 * tearing down and the /c scene mounting was a visible blink.
 *
 * This component is rendered by /compare ONLY on a client navigation with the
 * scene flag on (see compare/page.tsx). It keeps the SAME searching scene on
 * screen and performs a normal CLIENT navigation to /c - which is seamless,
 * exactly like the first navigation - so there is no blink. Hard GETs
 * (crawlers, direct URLs) and the flag-off path still get the server redirect,
 * so SEO and the no-JS path are unchanged.
 *
 * The scene is instant-opaque (see SearchingSceneOverlay), so it covers this
 * page and the /c loading boundary continuously until the saved page renders.
 */

import { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import type { Route } from "next";

import { SearchingSceneOverlay } from "@/components/comparison/SearchingSceneOverlay";

export function RedirectToSaved({ target }: { target: string }) {
  const router = useRouter();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    router.replace(target as Route);
  }, [target, router]);

  return (
    <SearchingSceneOverlay loaded={0} failed={0} total={0} isDone={false} />
  );
}
